import { ApplicationInsights, ITelemetryItem } from "@microsoft/applicationinsights-web";
import { configService } from "./Config/ConfigService";

class AppInsights {

    private appInsights: ApplicationInsights

    async load() {

        var config = await configService.getConfiguration()

        if (config.ApplicationInsights.ConnectionString) {
            this.appInsights = new ApplicationInsights({
                config: {
                    connectionString: config.ApplicationInsights.ConnectionString
                }
            });
            this.appInsights.loadAppInsights();
            this.appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
            var telemetryInitializer = (envelope : ITelemetryItem) => {
                envelope.tags["ai.cloud.role"] = "physicianportal";
            }
            this.appInsights.addTelemetryInitializer(telemetryInitializer);
        }
    }

    async logError(ex: Error){
        if (!this.appInsights) return;
        if (!ex) return;

        if (ex && ex.message){
            this.appInsights.trackException({exception: ex});
        }
        else {
            this.appInsights.trackException({exception: new Error(JSON.stringify(ex))});
        }
    }
}
export const appInsights = new AppInsights();